import { ChangeEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { completeSmsAuthentication } from '../../../services/accountService';
import { useHistory } from 'react-router';
import { setUserData } from './../../../redux/member';
import { VERIFY_PROFILE } from "../../../navigation/Constants";

const Verify = ({ code, phoneNumber, setPhoneNumber, getVerifyCode, isFromNeedToVerifyProfile, showInfoModal }: any) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const member = useSelector((state: RootState) => state.member);
    const [codenumberOne, setCodenumberOne] = useState<string>("");
    const [codenumberTwo, setCodenumberTwo] = useState<string>("");
    const [codenumberThree, setCodenumberThree] = useState<string>("");
    const [codenumberFour, setCodenumberFour] = useState<string>("");
    const [errors, setErrors] = useState<any>({});

    const validateForm = () => {
        let isvalid = true;
        let errors: any = {};
        const getCode = `${codenumberOne}${codenumberTwo}${codenumberThree}${codenumberFour}`;
        if (code !== Number(getCode)) {
            errors["code"] = "הקוד שהקלדת שגוי, שננסה שוב?";
            isvalid = false;
        }
        setErrors(errors);
        return isvalid;
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>, setFn: (val: string) => void) => {
        const { maxLength, value, name } = event.target;
        const [fieldName, fieldIndex] = name.split("-");

        // Check if they hit the max character length
        if (value.length >= maxLength) {
            // Check if it's not the last input field
            if (parseInt(fieldIndex, 10) < 4) {
                // Get the next input field
                const nextSibling: any = document.querySelector(
                    `input[name=codenumber-${parseInt(fieldIndex, 10) + 1}]`
                );

                // If found, focus the next field
                if (nextSibling) {
                    nextSibling.focus();
                }
            }
        }
        setFn(value);
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        setErrors({});
        event.preventDefault();
        if (validateForm()) {
            await completeSmsAuthentication({ memberCode: member.memberCode, phoneNumber: phoneNumber });
            member.hasBeenAuthenticatedByPhone = true;
            dispatch(setUserData(member));
            if (isFromNeedToVerifyProfile) history.push(VERIFY_PROFILE)
            else history.goBack();
            //go back to home screen
        }
    };

    const enabled =
        codenumberOne.length > 0 && codenumberTwo.length > 0
        && codenumberThree.length > 0 && codenumberFour.length > 0


    return (
        <div className="content_sec wf-section">

            <div className="signup_top_info">
                <div className="icon_info">
                    <img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" />
                </div>
                <h2 className="signup_title">שלחנו לך קוד לנייד</h2>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>{`שלחנו הודעת sms עם קוד האימות למספר ${phoneNumber}`}</div>
            </div>
            <div className="login_sec w-form signup_top_info">
                <form onSubmit={handleSubmit} >
                    <div style={{ display: errors && errors["code"] ? "contents" : "block" }} className="form_allert">{errors["code"]}</div>

                    <div style={{ direction: "ltr" }} className="field_quatro_group">
                        <div className="field_block quatro">
                            <input autoComplete="off" name="codenumber-1" onFocus={() => setCodenumberOne('')} type="tel" value={codenumberOne} onChange={e => handleChange(e, setCodenumberOne)} maxLength={1} className="txt_field w-input" />
                        </div>
                        <div className="field_block quatro">
                            <input autoComplete="off" name="codenumber-2" onFocus={() => setCodenumberTwo('')} type="tel" value={codenumberTwo} onChange={e => handleChange(e, setCodenumberTwo)} maxLength={1} className="txt_field w-input" />
                        </div>
                        <div className="field_block quatro">
                            <input autoComplete="off" name="codenumber-3" onFocus={() => setCodenumberThree('')} type="tel" value={codenumberThree} onChange={e => handleChange(e, setCodenumberThree)} maxLength={1} className="txt_field w-input" />
                        </div>
                        <div className="field_block quatro">
                            <input autoComplete="off" name="codenumber-4" onFocus={() => setCodenumberFour('')} type="tel" value={codenumberFour} onChange={e => handleChange(e, setCodenumberFour)} maxLength={1} className="txt_field w-input" />
                        </div>
                        <br />
                        <br />
                        <br />

                        <input autoComplete="off" disabled={!enabled} type="submit" value="המשך" data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                    </div>
                    <br />
                    <a href="#" className="send_again" style={{ fontSize: '1rem', margin: '20px auto' }} onClick={() => { getVerifyCode(phoneNumber); showInfoModal(); }}>
                        לא קיבלתי, שלחו שוב
                    </a>

                </form>

            </div>
        </div >

    )
}

export default Verify;